<template>
  <div>
    <div class="columns is-multiline is-marginless is-paddingless">
      <div class="column is-12 is-paddingless">
        <div class="level mb-20">
          <div class="level-left">
            <upload-image
              :value="panneau.srcImg"
              :disabled="disabled"
              :item-id="panneau.guid"
              :save-to-db="true"
              @error="$emit('msg-error', $event || $t('general.msgErrorDropdown'))"/>
          </div>
          <div class="level-item is-width-100p-148px pl-10">
            <div class="column columns is-multiline is-marginless is-paddingless">
              <div class="column is-paddingless is-12">
                <b-field class="pl-10 mb-20">
                  <template slot="label">
                    <qd-label :label="$t('creerPanneau.labelChamp.adresse')" required />
                  </template>
                  <AutoCompleteAdresse
                    @place_change="changeAdresse"
                    @error="$emit('msg-error', $event)"
                    :is-error="error.adresseError"
                    :libelle="libelleAdresse"
                    :disabled="disabled"/>
                </b-field>
              </div>
              <div class="column is-paddingless is-12">
                <b-button
                  type="is-primary"
                  class="ml-10"
                  @click="changeStreetView"
                  :disabled="disabled || !panneau.adresse.coordonnees">
                  <p class="is-size-14px has-text-weight-bold">
                    {{ panneau.streetView ? $t('general.btnMap') : $t('general.btnStreetView') }}
                  </p>
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-multiline">
      <qd-adresse
        :adresse="panneau.adresse"
        :disabled="disabled"
        :error="error.adresse"
        class="is-marginless" />
      <div class="column is-6 pa-10">
        <b-field v-bind="bFieldDataRegie" custom-class="mb-4px">
          <template slot="label">
            <qd-label :label="$t('creerPanneau.labelChamp.regie')" required />
          </template>
          <b-autocomplete
            v-model="panneau.regie"
            :data="filteredDataRegie"
            :disabled="disabled"
            :clearable="!disabled"
            :loading="isLoadingRegie"
            @select="selectRegie"
            ref="autocompleteRegie"
            field="nomCommercial"
            open-on-focus
            keep-first>
          </b-autocomplete>
        </b-field>
      </div>
      <div class="column is-6 pa-10">
        <b-field custom-class="mb-4px" :type="error.referenceConfrere ? 'is-danger' : ''">
          <template slot="label">
            <qd-label :label="$t('creerPanneau.labelChamp.referenceConfrere')" required />
          </template>
          <b-input
            v-model="panneau.referenceConfrere"
            :placeholder="$t('creerPanneau.labelChamp.referenceConfrere')"
            :disabled="disabled">
          </b-input>
        </b-field>
      </div>
      <div class="column is-6 pa-10">
        <b-field
          custom-class="mb-4px"
          :type="error.categorie ? 'is-danger' : ''">
          <template slot="label">
            <qd-label :label="$t('creerPanneau.labelChamp.categorie')" required />
          </template>
          <b-select
            :value="panneau.categorie"
            @input="selectCategorie"
            :disabled="disabled"
            expanded>
            <option
              v-for="el in produitsLocationOption"
              :key="el.id"
              :value="el">
              {{el.libelle}}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-6 pa-10">
        <parametre-autocomplete
          v-model="format"
					custom-class="mb-4px"
          :target="constantes.PARAMETRES_KEYS.materielFormat"
          :create="false"
          :label="$t('creerPanneau.labelChamp.format')"
          :error="error.format"
          :disabled="disabled"
          required
        />
      </div>
      <div class="column is-6 pa-10">
        <parametre-autocomplete
          v-model="materiel"
					custom-class="mb-4px"
          :target="constantes.PARAMETRES_KEYS.materielType"
          :create="false"
          :label="$t('creerPanneau.labelChamp.materiel')"
          :error="error.materiel"
          :disabled="disabled"
          required
        />
      </div>
      <div class="column is-6 pa-10">
        <b-field custom-class="mb-4px">
          <template slot="label">
            <qd-label :label="$t('creerPanneau.labelChamp.azimut')" />
          </template>
          <b-autocomplete
            :data="listeAzimut"
            :value="`${panneau.azimut}°`"
            :disabled="disabled"
            @select="selectAzimut"
            ref="autocomplete"
            icon="chevron-down"
            open-on-focus>
            <template slot-scope="props">
              <div class="media">
                <div class="media-left">
                  <img width="16" :src="getImgIconAzimut(props.option)">
                </div>
                <div class="media-content">
                  {{ props.option }}
                </div>
              </div>
            </template>
          </b-autocomplete>
        </b-field>
      </div>
      <div class="column is-3 pa-10">
        <b-field
          custom-class="mb-4px"
          :type="error.disposition ? 'is-danger' : ''"
          :message="error.disposition ? $t('creerPanneau.error.disposition') : ''">
          <template slot="label">
            <qd-label :label="$t('creerPanneau.labelChamp.disposition')"/>
          </template>
          <b-input
            v-model="panneau.disposition"
            :placeholder="$t('creerPanneau.labelChamp.disposition')"
            :disabled="disabled">
          </b-input>
        </b-field>
      </div>
      <div class="column is-3 pa-10">
        <b-field v-bind="bFieldDataSurface" custom-class="mb-4px">
          <template slot="label">
            <qd-label :label="$t('creerPanneau.labelChamp.pourcentageSurface')" required />
          </template>
          <b-input
            v-model.number="panneau.pourcentageSurface"
            type="number"
            min="0"
            max="100"
            step="any"
            :disabled="disabled">
          </b-input>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as configPanneau from '@/configuration/configPanneau';
import { PARAMETRES_KEYS } from '@/store/modules/parametrage-mutation-type';
import { SET_MARKER_PANNEAU } from '@/store/modules/recommandations-mutation-type';
import { getImgIconAzimut, adressFullStringGetter } from '@/services/general/general';
import adresseGenerer from '@/services/general/genererAdresse';
import { getIconPanneau } from '@/services/gestionIcon/iconColorGetter';
import { panneauToMarker} from '@/services/recommandation/recommandations';
import QdLabel from '@/components/general/qdLabel.vue';
import QdAdresse from '@/components/general/qdAdresse.vue';
import UploadImage from '@/components/general/uploadImage.vue';
import AutoCompleteAdresse from '@/components/general/autoCompleteAdresse.vue';
import ParametreAutocomplete from '@/components/general/parametreAutocomplete.vue';
import { genererRemiseFromTauxNegocie } from '@/services/devis/gestionTauxNegocies';
import { calculNetBudget } from '@/services/devisCommandes/calcul/calculRemisePanneau';
import { getTarif } from '@/services/gestionPanneau/getGrilleTarif';
import today from '@/services/general/today';
import { SURFACE_MAX } from '@/services/gestionPanneau/surfacePanneau';

const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametrage');
const Recommandations = createNamespacedHelpers('recommandations');

export default {
  props: {
    panneau: Object,
    error: Object,
    isLoadingRegie: Boolean,
    regies: Array,
    surfaceOccupee: {
      type: Number,
      default: 0,
    },
  },
  components: {
    QdLabel,
    QdAdresse,
    UploadImage,
    AutoCompleteAdresse,
    ParametreAutocomplete,
  },
  data () {
    return {
      modalFormat: false,
      modalMateriel: false,
      constantes: { PARAMETRES_KEYS },
      listeAzimut: configPanneau.LISTE_AZIMUT,
    };
  },
  watch: {
    'markerPanneau.coordonnees'(coordonnees) {
      if (!coordonnees) return;
      this.panneau.adresse = {
        ...this.panneau.adresse,
        latitude: coordonnees.lat,
        longitude: coordonnees.lng,
        coordonnees,
      };
    },
    'markerPanneau.streetView'(value) {
      this.panneau.streetView = value;
    },
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Recommandations.mapGetters({
      markerPanneau: 'markerPanneau',
      produitsLocation: 'produitsLocation',
      pointDeVente: 'pointDeVente',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    materiel: {
      get() {
        const value = this.panneau.materiel ? this.panneau.materiel.trim() : '';
        const data = this.parametre(PARAMETRES_KEYS.materielType)
          .find(el => value.toLowerCase() === el.libelle.toLowerCase().trim());
        return data ? data.id : null;
      },
      set(val) {
        const data = this.parametre(PARAMETRES_KEYS.materielType).find(el => val === el.id);
        this.panneau.materiel = data ? data.libelle : '';
      }
    },
    format: {
      get() {
        const value = this.panneau.format ? this.panneau.format.trim() : '';
        const data = this.parametre(PARAMETRES_KEYS.materielFormat)
          .find(el => value.toLowerCase() === el.libelle.toLowerCase().trim());
        return data ? data.id : null;
      },
      set(val) {
        const data = this.parametre(PARAMETRES_KEYS.materielFormat).find(el => val === el.id);
        this.panneau.format = data ? data.libelle : '';
        this.panneau.formatId = data ? data.id : null;
        this.initialiseFraisTech();
      }
    },
    libelleAdresse() {
      return adressFullStringGetter(this.panneau.adresse);
    },
    bFieldDataRegie() {
      let result = { type: '', message: '' };
      const regie = this.regies.find(r => r.nomCommercial === this.panneau.regie);
      if (regie && regie.archive) {
        result.type = 'is-warning';
        result.message = this.$t('creerPanneau.messageWarningArchiveRegie');
      }
      if (this.error.regie) {
        result.type = 'is-danger';
      }
      return result;
    },
    bFieldDataSurface() {
      if (this.error.pourcentageSurface) {
        return { type: 'is-danger', message: this.$t('creerPanneau.error.pourcentageSurface') };
      }
      if (this.surfaceOccupee + (this.panneau.pourcentageSurface || 0) > SURFACE_MAX) {
        return {
          type: 'is-warning',
          message: this.$t('creerPanneau.messageWarningSurface', { surfaceOccupee: this.surfaceOccupee }),
        };
      }
      return { type: '', message: '' };
    },
    filteredDataRegie() {
      return this.filterListFunc(this.regies, this.panneau.regie || '', 'nomCommercial')
        .filter(op => op.archive === false);
    },
    filteredDataFormat() {
      return this.filterListFunc(this.list.format, this.panneau.format || '', 'nom');
    },
    filteredDataMateriel() {
      return this.filterListFunc(this.list.materiel, this.panneau.materiel || '', 'nom');
    },
    disabled() {
      return this.$route.name === 'view-panneau';
    },
    produitsLocationOption() {
      return this.produitsLocation.map(el => ({
        id: el.id,
        libelle: el.libelle,
        couleur: el.couleurHtmlRgb,
      }));
    }
  },
  methods: {
    ...Recommandations.mapMutations({
      setMarkeurPanneau: SET_MARKER_PANNEAU,
    }),
    ...Recommandations.mapActions({
      loadProduitsLocation: 'loadProduitsLocation',
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    filterListFunc(data, val, field) {
      return data.filter((op) => op[field].toString().toLowerCase().indexOf(val.toLowerCase()) >= 0);
    },
    changeAdresse(adresse) {
      this.panneau.adresse = adresseGenerer(adresse);
      this.setMarkeurPanneau(panneauToMarker(this.panneau));
    },
    changeStreetView() {
      this.panneau.streetView = !this.panneau.streetView;
      this.setMarkeurPanneau(panneauToMarker(this.panneau));
    },
    getImgIconAzimut(azimut) {
      return getImgIconAzimut(azimut);
    },
    classCssModif() {
      const classControl = this.$refs.autocomplete.$el.querySelector('.control');
      classControl.classList.remove('has-icons-left');
      classControl.classList.add('has-icons-right');
      const classIcon = classControl.querySelector('.icon');
      classIcon.classList.remove('is-left');
      classIcon.classList.add('is-right');
    },
    setIconPanneau() {
      this.panneau.icon = getIconPanneau(this.panneau);
      this.setMarkeurPanneau(panneauToMarker(this.panneau));
    },
    async selectRegie(option) {
      this.panneau.regieId = option ? option.id : '';
      this.panneau.regie = option ? option.nomCommercial : '';
      await this.setRemiseFromTaux(option);
    },
    async setRemiseFromTaux(option) {
      const dateDebut = this.panneau.budgetGeneration && this.panneau.budgetGeneration.dateDebut;
      if (!dateDebut || !option) return;
      const annee = new Date(dateDebut).getFullYear();
      const taux = (option.tauxNegociations || []).find(tn => tn.annee === annee && tn.actif);
      if (!taux) return;
      const remise = await genererRemiseFromTauxNegocie(taux);
      this.panneau.budgetGeneration.remise = { ...remise };
      calculNetBudget(this.panneau.budgetGeneration);
      this.panneau.budgets.forEach(bloc => {
        bloc.remise = { ...remise };
        calculNetBudget(bloc);
      });
    },
    selectAzimut(option) {
      if (!option) return;
      this.panneau.azimut = parseInt(option.split('°')[0]);
      this.setIconPanneau();
    },
    selectCategorie(option) {
      if (!option) return;
      this.panneau.categorie = option;
      this.setIconPanneau();
    },
    initialiseFraisTech() {
      const critere = {
        enseigneId: this.pointDeVente.tiersParentId,
        formatId: this.panneau.formatId,
        produitFaceId: this.panneau.id,
        dateVisu: today(),
      };
      if (this.panneau.budgetGeneration && this.panneau.budgetGeneration.dateDebut) {
        getTarif(critere, this.panneau.budgetGeneration);
      }
      this.panneau.budgets.forEach(bloc => {
        if (!bloc.dateDebut) return;
        getTarif(critere, bloc);
      });
    },
  },
  async mounted() {
    await Promise.all([
      this.loadParametres([
        PARAMETRES_KEYS.materielFormat,
        PARAMETRES_KEYS.materielType,
      ]),
      this.loadProduitsLocation(),
    ]);
    this.setIconPanneau();
    this.classCssModif();
  }
}
</script>
